import { useTranslation } from 'react-i18next';
import { WithForm } from 'src/shared/HOC/WithForm';
import { Box, Button, Divider, Typography } from '@mui/material';
import Grid2 from '@mui/material/Unstable_Grid2/Grid2';
import { ModalTitleWrapper } from './styles';
import type { CustomModalProp } from 'src/modules/SaldoView/types';
import DOMPurify from 'dompurify';

export const InformationModal = ({
  closeModal,
  StepsComponent,
  title,
  description,
  initialValues,
  footerText
}: CustomModalProp) => {
  const { t } = useTranslation('overview');
  const PAYFLOW_DIGITAL_INC_SPAIN = 'Payflow Digital Inc Sucursal en España';

  return (
    <Grid2>
      <Box>
        <ModalTitleWrapper sx={{ textAlign: 'left' }}>{title}</ModalTitleWrapper>
        <Divider sx={{ margin: '1rem -32px' }} />
      </Box>
      <Typography mb={2} sx={{ textAlign: 'left' }}>
        {description}
      </Typography>
      <Grid2>
        <WithForm
          initialValues={{
            ...initialValues,
            companyName: initialValues?.companyName ?? '',
            IBAN: initialValues?.IBAN ?? '', // update to IBAN
            beneficiaryName: PAYFLOW_DIGITAL_INC_SPAIN // update to beneficiary
          }}
        >
          <StepsComponent />
        </WithForm>
      </Grid2>
      {footerText && (
        <Grid2>
          <Typography
            variant="body1"
            dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(footerText) }}
            sx={{ textAlign: 'left' }}
          ></Typography>
        </Grid2>
      )}
      <Grid2 mt={2} sx={{ textAlign: 'right' }}>
        <Divider sx={{ margin: '1rem -32px' }} />
        <Button variant="text" onClick={closeModal}>
          {t('cancel', { ns: 'common' })}
        </Button>
      </Grid2>
    </Grid2>
  );
};
